import { friendlyDatesHelper, friendlyDatesHelperReturn } from 'helpers';

export const useFriendlyDate = (
  start: string | Date,
  end: string | Date,
  timezone = 'US/Central',
): friendlyDatesHelperReturn => {
  return friendlyDatesHelper({ start, end, timezone });
};
